import { Box, BoxProps, CircularProgress, Grid, alpha, useTheme } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

export interface ILoaderProps extends BoxProps {
  size?: number;
  color?: string;
  isAbsolute?: boolean;
  absoluteBackgroundColor?: string;
}

/**
 * Лоадер на основе MUI CircularProgress. Компонент наследует пропсы от BoxProps для контейнера лоадера.
 *
 * @param size - размер лоадера. По умолчанию: 32.
 * @param color - цвет лоадера. По умолчанию: primary.main.
 * @param isAbsolute - включает абсолютное позиционирование контейнера лоадера, тем самым заполняет родительскую область с "position: relative" и отображает лоадер в центре.
 * @param absoluteBackgroundColor - фон контейнера с абсолютным позиционированием.
 */
export const Loader: React.FC<ILoaderProps> = (props) => {
  const { size = 32, isAbsolute = false, color, absoluteBackgroundColor, className, ...rest } = props;

  const { palette } = useTheme();
  const { classes, cx } = useStyles();

  // Renders

  const renderLoader = () => {
    return (
      <Grid container justifyContent="center" alignItems="center">
        <Box display="flex" color={color || palette.primary.main}>
          <CircularProgress size={size} color="inherit" />
        </Box>
      </Grid>
    );
  };

  if (isAbsolute) {
    return (
      <Box className={cx(classes.loader, className)} {...rest}>
        <div
          className={classes.overlay}
          style={{ backgroundColor: absoluteBackgroundColor || alpha(palette.common.white, 0.7) }}
        />

        {renderLoader()}
      </Box>
    );
  }

  return (
    <Box className={cx(classes.container, className)} {...rest}>
      {renderLoader()}
    </Box>
  );
};

const useStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    flexBasis: '100%',
  },
  loader: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: -1,
  },
}));
